export const isEmbedded = (): boolean => ("webkit" in window && "iosListener" in (window as any).webkit.messageHandlers);

export const notifyHost = (msg:string): void => {
    if (isEmbedded()) {
        (window as any).webkit.messageHandlers.iosListener.postMessage(msg);
    }
};
